import React from "react";
import { PageHeader } from "@features/shared";

/**
 * PageLayout Component
 * Standard page layout with header and content container
 * 
 * @component
 * @param {string} title - Page header title
 * @param {string} backPath - Navigation path for back button (default: "/")
 * @param {ReactNode} children - Page content
 */
const PageLayout = ({ title, backPath = "/", children }) => {
  return (
    <>
      <PageHeader title={title} path={backPath} />
      <div className="container p-0">
        {children}
      </div>
    </>
  );
};

export default PageLayout;
